import tcAutoFocus from './TcAutoFocus';

export default tcAutoFocus;
